import { render, staticRenderFns } from "./LinkHelpdeskModal.vue?vue&type=template&id=0cc84607&"
import script from "./LinkHelpdeskModal.vue?vue&type=script&lang=js&"
export * from "./LinkHelpdeskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports